import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/shared/interfaces/usuario/usuario.interface';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { UsuarioAPIService } from '../../../services/usuario-api.service';
import { UsuarioLogin } from 'src/app/shared/interfaces/usuario/usuario-login.interface';
import { ToastrService } from 'ngx-toastr';
import { PermissaoMenu } from 'src/app/shared/interfaces/acesso/permissao-menu.interface';
import { AcessoAPIService } from '../../../services/acesso-api.service';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SessaoService } from 'src/app/shared/services/sessao.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public usuarioLogin: UsuarioLogin = { login: '', senha: '' };
  public loginRecuperacao: string = '';
  public isLoading = false;

  constructor(private router: Router, 
    private usuarioService: UsuarioService,
    private usuarioAPIService: UsuarioAPIService, 
    private acessoService: AcessoAPIService,
    private sessao: SessaoService,
    private toastr: ToastrService) { }

  ngOnInit() {
  }

  login(){
    
      this.usuarioAPIService.login(this.usuarioLogin).subscribe((data: any) => {       
        if(data.token){
          this.sessao.guardarToken(data.token, data.expiraEmSegundos); 
          const decodedToken = this.usuarioService.decodeToken(data.token);         

          this.usuarioAPIService.getById(decodedToken.sub).subscribe(async (usuario: Usuario) => {
            //var permissoes = await firstValueFrom(this.acessoService.getAllAcesso(usuario.id)) as PermissaoMenu[];  
            //usuario.permissaoMenus = permissoes;
            const localUser = JSON.stringify(usuario);
            localStorage.setItem('usuario', localUser);
            localStorage.setItem('versao', environment.versao.toString());
            this.usuarioService.setUsuarioLogado(usuario.id, usuario.nome, usuario.email, usuario.permissoes, usuario.imagemPerfil, usuario.menus, usuario.setoresAprovador, usuario.chamadosNaoVisualizados );
            sessionStorage.removeItem('sacpmPendenciasVerificadas');
            sessionStorage.removeItem('justificativaAtrasoVerificada');
            sessionStorage.removeItem('motivoAgExpedicaoVerificado');
            sessionStorage.removeItem('pendenciasModalUltimoId');
            this.router.navigateByUrl('/dashboard')
          });       
        }
      }, (response) => { 
        if(response.error.message == "Trocar senha."){

          this.toastr.warning('Você deve trocar sua senha.\nVocê será redirecionado...', 'Nova senha'); 

          setTimeout(() => {
            var link = response.error.errors[0];
            window.open(link);  
          }, 2000)                  
          return;
        }

        this.toastr.error(`Motivo: ${response.error.message}`, 'Erro ao fazer Login'); 
      });
    
  }

  esqueciSenha(){
    const modal = document.getElementById('recuperarSenhaModal') as any;
    if (modal) {
      const bootstrapModal = new (window as any).bootstrap.Modal(modal);
      bootstrapModal.show();
    }
  }

  recuperarSenha(){
    this.isLoading = true;
    if (this.loginRecuperacao) {
      this.usuarioAPIService.recuperarSenha(this.loginRecuperacao).subscribe(
        (response: any) => {
          this.isLoading = false;
          this.toastr.success('Um e-mail com instruções para recuperação de senha foi enviado.', 'Sucesso');
          this.loginRecuperacao = '';
          const modal = document.getElementById('recuperarSenhaModal') as any;
          if (modal) {
            const bootstrapModal = (window as any).bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
              bootstrapModal.hide();
            }
          }
        },
        (error) => {
          this.toastr.error(`Motivo: Login não encontrado.`, 'Erro ao recuperar senha');
          this.isLoading = false;
        }
      );
    }
  }
}


